module.exports = __webpack_public_path__ + "static/img/money.58e2e19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/money.png
// module id = X3s9
// module chunks = 0